import {
  ICancelMultipleOtapForm,
  ICancelOtapForm,
  IIntitiateMultipleOtapForm,
  IIntitiateOtapForm
} from '~/models'
import axiosClient from './axiosClient'
import {
  CANCEL_MULTIPLE_OTAP_API,
  INDIVIDUAL_MANIFEST_API,
  INITIATE_MULTIPLE_OTAP_API
} from '~/constants/APIs'

export const individualManfestApis = {
  initiateOtap: (data: IIntitiateOtapForm) =>
    axiosClient.post(INDIVIDUAL_MANIFEST_API + data.otapId + '/initiateotap', data),
  cancelOtap: (data: ICancelOtapForm) =>
    axiosClient.post(INDIVIDUAL_MANIFEST_API + data.otapId + '/cancelotap', data),
  initiateGroupOtap: (groupId: number | string, data: IIntitiateMultipleOtapForm) =>
    axiosClient.post(INDIVIDUAL_MANIFEST_API + groupId + '/initiategroupotap', data),
  cancelGroupOtap: (groupId: number | string) =>
    axiosClient.post(INDIVIDUAL_MANIFEST_API + groupId + '/cancelgroupotap'),
  initiateMultipleDeviceOtap: (data: IIntitiateMultipleOtapForm) =>
    axiosClient.post(INITIATE_MULTIPLE_OTAP_API, data),
  cancelMultipleDeviceOtap: (data: ICancelMultipleOtapForm) =>
    axiosClient.post(CANCEL_MULTIPLE_OTAP_API, data),
  getErrorDetailsLog: (id: number) =>
    axiosClient.get(INDIVIDUAL_MANIFEST_API + id + '/errordetailslog', {
      responseType: 'blob'
    })
}
